import { createSelector } from 'reselect'
import { localize } from 'helpers/translator'

const getUserData = state => state.user
const getMyAccountData = state => state.myAccount

const defaultData = {
	maxUploadImageSize: 0,
	image: '',
}

const profilePictureSelector = createSelector(
	[ getUserData, getMyAccountData ],
	(userData, myAccountData) => {
		let userMyAccountData = {}
		if (userData.data.account) {
			userMyAccountData.userId = userData.data.userId
			userMyAccountData.image = userData.data.image
			userMyAccountData.maxUploadImageSize = localize('my_account_profile_header_image_tooltip') + userData.data.maxUploadImageSize + localize('my_account_profile_header_image_mb')
		} else {
			userMyAccountData = defaultData
		}

		return {
			userId: userMyAccountData.userId,
			image: userMyAccountData.image,
			maxUploadImageSize: userMyAccountData.maxUploadImageSize,
			showProfileImageUploading: myAccountData.showProfileImageUploading,
		}
	}
)

export default profilePictureSelector
